import React from 'react';
import toastr from 'toastr';
import { LANDING_COMPONENT_TYPES, COMPONENT_LABELS } from './landingComponents';
import { buildMarkerHtml, buildMarkerRow } from './markerBlocks';

const COMPONENTS = [
  { type: LANDING_COMPONENT_TYPES.leadForm, icon: 'bx-detail' },
  { type: LANDING_COMPONENT_TYPES.callbackOrCall, icon: 'bx-phone-incoming' },
  { type: LANDING_COMPONENT_TYPES.clickToCall, icon: 'bx-phone-call' },
  { type: LANDING_COMPONENT_TYPES.gallery, icon: 'bx-images' },
];

const copyMarker = (type) => {
  const marker = buildMarkerHtml(type);
  if (!navigator.clipboard) {
    toastr.info(marker, 'Copy this marker');
    return;
  }
  navigator.clipboard.writeText(marker).then(
    () =>
      toastr.success(
        'Marker copied. Paste it into an HTML block.',
        COMPONENT_LABELS[type],
      ),
    () => toastr.error('Could not copy the marker.', COMPONENT_LABELS[type]),
  );
};

const LandingComponentInserter = ({ editorRef }) => {
  const insert = (type) => {
    const editor = editorRef.current && editorRef.current.editor;
    if (!editor) {
      toastr.error('The editor is not ready yet.', 'Landing components');
      return;
    }
    editor.saveDesign((design) => {
      const body = design && design.body ? design.body : { rows: [] };
      const next = {
        ...design,
        body: { ...body, rows: [...(body.rows || []), buildMarkerRow(type)] },
      };
      editor.loadDesign(next);
      toastr.success(
        'Added at the bottom of the page — drag it into place. (Undo history is reset.)',
        COMPONENT_LABELS[type],
      );
    });
  };

  return (
    <div className="mt-3">
      <h6 className="font-size-13 mb-2">Landing Components</h6>
      {COMPONENTS.map(({ type, icon }) => (
        <div key={type} className="d-flex align-items-center mb-2">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm flex-grow-1 text-left"
            onClick={() => insert(type)}>
            <i className={`bx ${icon} align-middle mr-2`} />
            {COMPONENT_LABELS[type]}
          </button>
          <button
            type="button"
            className="btn btn-link btn-sm text-muted px-1"
            title="Copy raw marker"
            onClick={() => copyMarker(type)}>
            <i className="bx bx-copy" />
          </button>
        </div>
      ))}
      <p className="text-muted small mb-0">
        Components are configured below and become live forms at publish.
      </p>
    </div>
  );
};

export default LandingComponentInserter;
